// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help_popup {
  margin-top: 20px;
  text-align: center;
  --background: #fff2e7;
}
.help_popup h3 {
  color: #dbb49f;
  margin-bottom: 15px;
  width: 80%;
  margin: auto;
  display: block;
  font-weight: bold;
}
.help_popup h4 {
  color: #dbb49f;
  font-weight: bold;
  font-size: 17px;
  text-align: left;
}
.help_popup h5 {
  font-size: 11px;
  text-align: left;
  width: 80%;
  margin-bottom: 30px;
  color: #978985;
}
.help_popup h6 {
  font-size: 10px;
  text-align: left;
  margin-left: 20px;
  color: #9a8579;
  width: 60%;
}
.help_popup p {
  font-size: 11px;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  color: #9f8577;
}
.help_popup img {
  width: 20%;
}
.help_popup .buttons {
  display: inline-flex;
  justify-content: space-around;
  grid-gap: 5px;
}
.help_popup .buttons button {
  padding: 20px;
  margin-top: 30px;
  background: #dbb49f;
  border: none;
  color: #fff;
  border-radius: 3px;
}
.help_popup .seller_button {
  display: inline-flex;
  justify-content: space-between;
  width: 85%;
  padding: 15px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
  background: none;
  border: 2px solid #dbb49f;
  color: #dbb49f;
  font-weight: 800;
  border-radius: 6px;
}
.help_popup .game_btn_section {
  background: rgba(219, 180, 159, 0.2);
  box-shadow: -1px 1px 10px #b8a5a5;
  padding: 21px;
  padding-top: 5px;
  border-radius: 8px;
  margin-top: 5%;
  margin-bottom: 22px;
  display: block;
  width: 85%;
  margin-left: auto;
  margin-right: auto;
}
.help_popup .game_btn_section .game_btn_grid {
  display: inline-flex;
  flex-wrap: wrap;
  grid-gap: 5px;
}
.help_popup .game_btn_section .game_btn_grid .game_btn {
  display: block;
  color: #dbb49f;
  border: 2px solid #dbb49f;
  background: none;
  border-radius: 4px;
  width: -moz-fit-content;
  width: fit-content;
  padding: 10px;
}
.help_popup .game_btn_section .game_btn_grid .selected {
  background: #dbb49f;
  color: #fff;
}
.help_popup .game_btn_section .filter_games_btn {
  width: 100%;
  padding: 10px;
  margin-top: 30px;
  background: #fff2e7;
  color: #e0beaa;
  border-radius: 4px;
  text-align: left;
  display: inline-flex;
  justify-content: space-between;
}
.help_popup .game_btn_section .filter_games_btn ion-icon {
  font-size: 20px;
  margin: 0;
  padding: 0;
}
.help_popup .game_btn_section .filter_games_btn .selected_btn {
  border: 2px solid rgba(232, 152, 93, 0.2588235294);
}`, "",{"version":3,"sources":["webpack://./src/app/welcome/welcome.page.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,kBAAA;EACA,qBAAA;AACJ;AACI;EACI,cAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AACR;AAEI;EACI,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAAR;AAGI;EACI,eAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;AADR;AAII;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAFR;AAKI;EACI,eAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAHR;AAMI;EACI,UAAA;AAJR;AAOI;EACI,oBAAA;EACA,6BAAA;EACA,aAAA;AALR;AAOQ;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AALZ;AASI;EACI,oBAAA;EACA,8BAAA;EAEA,UAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AATR;AAYI;EACI,oCAAA;EACA,iCAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AAVR;AAYQ;EACI,oBAAA;EACA,eAAA;EACA,aAAA;AAVZ;AAYY;EACI,cAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,aAAA;AAVhB;AAaY;EACI,mBAAA;EACA,WAAA;AAXhB;AAcQ;EACI,WAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,8BAAA;AAZZ;AAcY;EACI,eAAA;EACA,SAAA;EACA,UAAA;AAZhB;AAeY;EACI,kDAAA;AAbhB","sourcesContent":[".help_popup {\n    margin-top: 20px;\n    text-align: center;\n    --background: #fff2e7;\n\n    h3 {\n        color: #dbb49f;\n        margin-bottom: 15px;\n        width: 80%;\n        margin: auto;\n        display: block;\n        font-weight: bold;\n    }\n\n    h4 {\n        color: #dbb49f;\n        font-weight: bold;\n        font-size: 17px;\n        text-align: left;\n    }\n\n    h5 {\n        font-size: 11px;\n        text-align: left;\n        width: 80%;\n        margin-bottom: 30px;\n        color: #978985;\n    }\n\n    h6 {\n        font-size: 10px;\n        text-align: left;\n        margin-left: 20px;\n        color: #9a8579;\n        width: 60%;\n    }\n\n    p {\n        font-size: 11px;\n        width: 80%;\n        margin-left: auto;\n        margin-right: auto;\n        color: #9f8577;\n    }\n\n    img {\n        width: 20%;\n    }\n\n    .buttons {\n        display: inline-flex;\n        justify-content: space-around;\n        grid-gap: 5px;\n\n        button {\n            padding: 20px;\n            margin-top: 30px;\n            background: #dbb49f;\n            border: none;\n            color: #fff;\n            border-radius: 3px;\n        }\n    }\n\n    .seller_button {\n        display: inline-flex;\n        justify-content: space-between;\n\n        width: 85%;\n        padding: 15px;\n        margin-left: auto;\n        margin-right: auto;\n        margin-bottom: 20px;\n\n        background: none;\n        border: 2px solid #dbb49f;\n        color: #dbb49f;\n        font-weight: 800;\n        border-radius: 6px;\n    }\n\n    .game_btn_section {\n        background: rgba(219, 180, 159, 0.2);\n        box-shadow: -1px 1px 10px #b8a5a5;\n        padding: 21px;\n        padding-top: 5px;\n        border-radius: 8px;\n        margin-top: 5%;\n        margin-bottom: 22px;\n        display: block;\n        width: 85%;\n        margin-left: auto;\n        margin-right: auto;\n\n        .game_btn_grid {\n            display: inline-flex;\n            flex-wrap: wrap;\n            grid-gap: 5px;\n\n            .game_btn {\n                display: block;\n                color: #dbb49f;\n                border: 2px solid #dbb49f;\n                background: none;\n                border-radius: 4px;\n                width: fit-content;\n                padding: 10px;\n            }\n\n            .selected {\n                background: #dbb49f;\n                color: #fff;\n            }\n        }\n        .filter_games_btn {\n            width: 100%;\n            padding: 10px;\n            margin-top: 30px;\n            background: #fff2e7;\n            color: #e0beaa;\n            border-radius: 4px;\n            text-align: left;\n            display: inline-flex;\n            justify-content: space-between;\n\n            ion-icon {\n                font-size: 20px;\n                margin: 0;\n                padding: 0;\n            }\n\n            .selected_btn {\n                border: 2px solid #e8985d42;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
